module.exports = __webpack_public_path__ + "static/media/expo0920.cd4468ed.jpg";